import { Lightbox } from 'ngx-lightbox';
import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appInspectImage]',
  standalone: true
})
export class InspectImageDirective {

  constructor(
    private _lightbox: Lightbox,
  ) {
  }

  @HostListener('click', ['$event.target'])
  onClick(image) {
    this._lightbox.open([{src: image.src, thumb: '', downloadUrl: ''}], 0, {
      centerVertically: true
    });
  }

}
